<div class="admin-headerbox">
    <div class="admin-headerbox-left">
        Welcome!
        <div class="admin-headerbox-caption">
            Thank you for participating with Delta Dental of Missouri and South Carolina! Begin your application below.
        </div>
        
    </div>
    <div class="admin-headerbox-right">
        <img src="assets/images/searchclaim-topbg.svg" width="888" height="252" alt="Logo" class="admin-headerbox-img" loading="eager">
    </div>
</div>

<section class="admin-mainformblock">
    <div class="benefits-innerbox">    
    <div class="main-content" [ngClass]="dataSource.data.length == 0 ? 'main-content-height' : 'main-content-height-table'">
        <div *ngIf="dataSource.data.length  == 0 && !isLoading ">
            <div class="icon-container">
                <img src="assets/images/start-icon.svg" alt="Icon">
            </div>
            <p class="subtext">There is no records to show</p>
            <h1 class="heading">Please start initial credentialing by clicking below.</h1>
            <app-button [label]="'Start'" id="Start" [buttonType]="'primary'" [isFilled]="true" (clicked)="onStart()"
                class=" btn-primary start-btn" [isDisabled]="impersonatedUser">
            </app-button>
        </div>

    <!-- Network Participation Section -->
    <div class="network-participation-section"  *ngIf="dataSource.data.length > 0 && !isLoading">
        <h2 class="section-heading">Network Participation</h2>
        <!-- Desktop Table View -->
        <div class="table-container desktop-only" #tableWrapper>
            <app-table class="participation-table" [data]="dataSource.data" 
            [ngClass]="{ 'action-required': showActionRequired, 'disable-action': impersonatedUser && action=='Recred',
            'disable-delete': impersonatedUser && hasDelete}"
            [columns]="tableColumns" id="tblAdmin" (clickEvent)="onTableClick($event)" >
            
          </app-table>
        </div>

        <!-- Mobile Card View -->
        <div class="cards-container mobile-only" *ngIf="tableData.length > 0">
            <div class="participation-card" *ngFor="let item of tableData">
                <div class="action-container">
                    @if(item.status && (item.status == 'Draft' || item.status == 'Submitted')) {
                        <span class="action" (click)="deletePopupCall()">
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="delete-icon"
                                data-action="DELETE">
                                <polyline points="3 6 5 6 21 6"></polyline>
                                <path d="M19 6l-1 14H6L5 6"></path>
                                <path d="M10 11v6"></path>
                                <path d="M14 11v6"></path>
                                <path d="M9 6V4h6v2"></path>
                            </svg>
                        </span>
                    }
                    <span class="action">
                        <img src="assets/icons/doc-file.svg" alt="Doc File" class="iconwidth1" (click)="openDocument()">
                    </span>
                </div>
                <div class="card-row">
                    <span class="card-label">Name</span>
                    <span class="card-value name-value">{{ item.name }}</span>
                </div>
                <div class="card-row">
                    <span class="card-label">Credentialing dates</span>
                    <span class="card-value">{{ item.credentialingDates }}</span>
                </div>
                <div class="card-row">
                    <span class="card-label">Recred</span>
                    <span class="card-value">{{ item.recred }}</span>
                </div>
                <div class="card-row">
                    <span class="card-label">Status</span>
                    <span class="card-value oj-status" [ngClass]="getOjStatusClass(item.status)">{{ item.status }}</span>
                </div>
                @if(item.action) {
                    <div class="card-row">
                        <span class="card-label">Action</span>
                        <button class="btn-recred" (click)="onRecred(item)">{{ item.action }}</button>
                    </div>
                }
            </div>
        </div>
    </div>
</div>
</div>

</section>
<app-loader></app-loader>